export const isAppRunningInIframe = () => {
    try {
        return window.self !== window.top
    } catch (e) {
        return true
    }
}

export default isAppRunningInIframe
